export default __webpack_public_path__ + "static/media/stan.3a93ce15.png";